<template>
  <div class="cpnt-app-select cpnt-app-campo" v-show="cpntMostrar" :class="cpntSelectMontarClass" ref='cpnt_select'>
    <!-- SETA O SELECT  -->
    <select :id="cpntId" ref='select' :tabIndex='cpntTabIndex' :disabled="cpntDisabled" :value="value">
      <!-- CRIA O BOTÃO DE ADICIONAR NOVO VALOR -->
      <option v-if="[ '', null, undefined ].indexOf(cpntNewOption) === -1 && cpntNewOption !== false" value="__ADD__NOVO_OPTION__"><i>Adicionar novo</i></option>

      <!-- COLOCA O OPTION SELECIONE -->
      <template v-if="[ '', null, undefined ].indexOf(cpntOptionInicialNome) === -1">
        <option :value="cpntOptionInicialValue" v-html="cpntOptionInicialNome"></option>
      </template>

      <!-- MONTA OS OPTIONS DO CAMPO -->
      <template v-for="(_option, index) in optionsV">
        <template v-if="_option.optgroup === undefined">
          <option :key="'option--' + index" v-if="cpntOptionInicialValue !== _option._id" :value="_option._id" v-html="_option._text"></option>
        </template>
        <optgroup v-else :key="'optgroup--' + index" :label="_option.optgroup">
          <template v-for="(_option2, index2) in _option.options">
            <option :key="'optgroup--' + index + '--' + index2" :value="_option2._id" v-html="_option2._text"></option>
          </template>
        </optgroup>
      </template>
    </select>
    
    <!-- SETA O ICONE DE CARREGANDO -->
    <div v-if="loading === true" class="cpnt-app-select-loading" title="Carregando...">
      <svg class="fas fa-spinner fa-spin"></svg>
    </div>

    <!-- SETA O CAMPO QUE VAI APRESENTAR ALETA -->
    <App-Button v-if="cpntAlerta !== ''" :cpntIcone="'alerta-amarelo'" :cpntExplica="{ mensagem: cpntAlerta }" :cpntClass="'btn btn-default btn-sm cpnt-app-campo-botao-alerta'"></App-Button>

    <!-- SETA A BARRA QUE APRESENTA ABAIXO DO INPUT -->
    <span class="cpnt-barra"></span>
    
    <!-- SETA O TITULO DO CAMPO -->
    <label :for='cpntId' v-if="[ '', null, undefined ].indexOf(cpntNome) === -1 || [ '', null, undefined ].indexOf(cpntExplica) === -1">
      <!-- SETA O NOME DO CAMPO -->
      <span v-if="[ '', null, undefined ].indexOf(cpntNome) === -1" v-html='cpntNome'></span>

      <!-- SETA A EXPLICAÇÃO DO CAMPO -->
      <App-Explica v-if="[ '', null, undefined ].indexOf(cpntExplica) === -1 && [ '', null, undefined ].indexOf(cpntExplica.mensagem) === -1"
        :cpntId='cpntId + "-explica"' 
        :cpntTitle='cpntExplica.mensagem'
        :cpntPositionMy='cpntExplica.posicaoMy'
        :cpntPositionAt='cpntExplica.posicaoAt'
        :cpntClasses='cpntExplica.class'
      ></App-Explica>
    </label>

    <!-- SETA UM AVISO ABAIXO DO CAMPO -->
    <span class="cpnt-has-error" v-if="[ '', null, undefined ].indexOf(cpntMensagem) === -1" v-html='cpntMensagem'></span>

    <!-- DIV MASCARA PARA FECHAR A TELA -->
    <!-- <div class="cpnt-select-mascara" @click="cpntSelectFechar"></div> -->

    <RF-Dialog v-if="novoOpt === true"
    :cpntLargura='"300px"'
    :cpntOnFecharDialog='cpntSelectNovoOptFechar'>
      <template slot='titulo'>      
        <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
        Adicionar nova opção
      </template>

      <template slot='conteudo'>
        <App-Input class="app-cpnt-field cpnt-select--nome" :class="campos.nome.class"
          :cpntStatus='campos.nome.status'
          :cpntId='campos.nome.id'
          :cpntClassDivField='campos.nome.classDivField'
          :cpntNome='campos.nome.nome'
          :cpntValue='campos.nome.value'
          :cpntAutoComplete='campos.nome.autocomplete'
          :cpntMask='campos.nome.mask'
          :cpntOptionInicialNome='campos.nome.optionInicialNome'
          :cpntOptionInicialValue='campos.nome.optionInicialValue'
          :cpntDisabled='campos.nome.disabled'
          :cpntMostrar='campos.nome.mostrar'
          :cpntAutoFocus='campos.nome.autofocus'
          :cpntMensagem='campos.nome.mensagem'
          :cpntMensagemTipo='campos.nome.mensagemTipo'
          :cpntPlaceholder='campos.nome.placeholder'
          :cpntPosicionar='campos.nome.posicionar'
          :cpntOnChange='campos.nome.onChange'
          :cpntOnBlur='campos.nome.onBlur'
          :cpntOnKeyPressEnter='campos.nome.onKeyPressEnter'
          :cpntExplica='campos.nome.explica'
          ref='nome'
        ></App-Input>
      </template>

      <template slot='rodape'>
        <div class="cpnt-select-botoes">
          <RF-Button
            :cpntStatus='botoes.cancelar.status' 
            :cpntId='botoes.cancelar.id' 
            :cpntTexto='botoes.cancelar.texto' 
            :cpntClass='botoes.cancelar.class'
            :cpntMostrar='botoes.salvar.mostrar'
            :cpntTabIndex='botoes.cancelar.tabIndex'
            @onClickButton='botoes.cancelar.onClick'
          ></RF-Button>

          <RF-Button
            :cpntStatus='botoes.salvar.status' 
            :cpntId='botoes.salvar.id' 
            :cpntTexto='botoes.salvar.texto' 
            :cpntClass='botoes.salvar.class'
            :cpntMostrar='botoes.salvar.mostrar'
            :cpntTabIndex='botoes.salvar.tabIndex'
            @onClickButton='botoes.salvar.onClick'
          ></RF-Button>
        </div>
      </template>
    </RF-Dialog>
  </div>
</template>

<style scoped>
.cpnt-app-select {
  width: 100%;
  position: relative;
  display: inline-block;
}
  .cpnt-app-select > select {
    display: none;
  }
  .cpnt-app-select > .cpnt-app-select-loading {
    position: absolute;
    top: calc(50% - 10px);
    right: 1px;
  }
  .cpnt-app-select > .cpnt-app-select-loading > svg {
    font-size: 20px;
    color: #777;
  }
  .cpnt-select-mascara {
    display: none;
    position: fixed;
    top: 0px;
    left: 0px;
    height: 100%;
    width: 100%;
  }
  .cpnt-app-campo > .cpnt-barra {
    top: 3px;
    width: calc(100% - 7px);
    margin: 0px auto;
  }

  .cpnt-app-select > .select2-dropdown-open ~ .cpnt-select-mascara {
    display: block;
  }

  .cpnt-select--nome {
    margin-top: 10px !important;
  }
  .cpnt-select-botoes {
    text-align: right;
  }
    .cpnt-select-botoes > button:not(:first-child) {
      margin-left: 5px;
    }
</style>

<style>
.cpnt-app-select > .select2-container {
  width: 100%;
}
  .cpnt-app-select > .select2-container > .select2-choice,
  .cpnt-app-select > .select2-container > .select2-choice > .select2-chosen,
  .cpnt-app-select > .select2-container > .select2-choice > .select2-arrow {
    height: 30px;
  }
  .cpnt-app-select > .select2-container > .select2-choice {
    color: inherit;
    background: #fff;
  }
  .select2-drop > .select2-results > .select2-result,
  .cpnt-app-select > .select2-container > .select2-choice {
    text-align: left;
    top: 1px;
    font-size: inherit;
  }
  .cpnt-app-select > .select2-container:not(.select2-container-active) > .select2-choice {
    border-radius: 5px;
    border: 1px solid #ccc;
  }
  .cpnt-app-select > .select2-container > .select2-choice > .select2-arrow {
    border-left: 1px solid #e1e1e1 !important;
    background: #f9f9f9 !important;
  }

  .cpnt-select-img-option {
    margin-right: 5px;
    width: 18px;
    height: 18px;
  }
  .cpnt-select-img-new-option {
    width: 12px;
    height: 12px;
    opacity: 0.7;
  }

  .cpnt-select-opt-group {
    display: none;
  }
  .cpnt-select2-optgroup {
    width: 100%;
    padding: 0px;
    line-height: normal;
  }
  .cpnt-select2-optgroup .cpnt-select2-optgroup-title {
    font-weight: bold;
  }
  .cpnt-select2-optgroup .cpnt-select2-value-selected {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
</style>

<script>
  import '../../../public/plugins/select2_345/select2.js'
  import '../../../public/plugins/select2_345/select2_locale_pt-BR.js'
  import '../../../public/plugins/select2_345/select2.css'

  export default {
    props: {
      cpntId: {
        required: false,
        type: String,
        default: function () {
          // INICIA A VARIAVEL ID
          var id = ''

          // INICIA PARA VERIFICAR SE ENCONTROU UM ID
          var flag = false

          while (flag === false) {
            // GERA UM ID PARA O CAMPO
            id = 'cpnt-select-' + (Math.floor(Math.random() * (9999 - 1000)) + 1000).toString() + '--'

            // VERIFICA SE O ID GERADO É UNICO NA TELA
            flag = [ '', null, undefined ].indexOf(document.getElementById(id)) !== -1
          }

          // RETONAR O VALOR MONTADO
          return id
        }
      },
      cpntSearchMinimo: {
        required: false,
        type: Number,
        default: function () {
          return 0
        }
      },
      cpntDebug: {
        required: false,
        type: Boolean,
        default: function () {
          return false
        }
      },
      cpntTabIndex: {
        required: false,
        type: Number,
        default: function () {
          return 0
        }
      },
      cpntValue: {
        required: true,
        validator: function (val) {
          return ([ 'string', 'number', 'object' ].indexOf(typeof val) !== -1)
        }
      },
      cpntFiltro: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntKeyValue: {
        type: String,
        required: true
      },
      cpntKeyMostra: {
        type: Array,
        required: true
      },
      cpntOptionInicialNome: {
        type: String,
        required: false,
        default: function () {
          return ''
        }
      },
      cpntOptionInicialValue: {
        type: String,
        required: false,
        default: function () {
          return ''
        }
      },
      cpntOptions: {
        type: Array,
        required: true
      },
      cpntOnBuscarOptions: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntMultiple: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntMostrar: {
        type: Boolean,
        required: false,
        default: function () {
          return true
        }
      },
      cpntDisabled: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntNewOption: {
        required: false,
        default: function () {
          return false
        }
      },
      cpntAlerta: {
        type: String,
        required: false,
        default: function () {
          return ''
        }
      },
      cpntExplica: {
        type: Object,
        required: false
      },
      cpntMensagem: {
        type: String,
        required: false,
        default: null
      },
      cpntNome: {
        required: true,
        type: [ String, Number ],
        default: function () {
          return ''
        }
      },
      cpntOptionBold: {
        type: String,
        required: false,
        default: null
      },
      
      cpntOnChange: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntOnKeyPressEnter: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    components: {
      'App-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue')
    },
    data: function () {
      return {
        select: null,
        loading: false,
        value: '',
        option: {},
        options: {},
        optionsV: [],
        buscarOption: true,

        config: {
          containerCssClass: '',
          dropdownCssClass: '',
          escapeMarkup: (m) => { return m },
          // formatResult: this.cpntSelectTratarOptionSelecionado,
          formatResult: (event) => { return this.cpntSelectTratarOptionSelecionado(event, false) },
          formatSelection: (event) => { return this.cpntSelectTratarOptionSelecionado(event, true) },
          placeholder: '',
          language: { noResults: () => { return 'Nenhum item encontrado.' } },
          debug: this.cpntDebug,
          disabled: this.cpntDisabled,
          minimumResultsForSearch: (this.cpntSearchMinimo <= 0 ? 0 : this.cpntSearchMinimo)
        },
        novoOpt: false,
        campos: {
          nome: {
            status: '',
            nome: 'Nome da nova opção',
            value: '',
            apiEnv: 'nome',
            onChange: this.cpntSelectOnChangeCampo,
            onKeyPressEnter: () => { this.cpntSelectNovoOptFechar(true) }
          }
        },
        botoes: {
          cancelar: {
            status: '',
            texto: 'Cancelar',
            class: [ 'btn', 'btn-default', 'btn-sm' ],
            mostrar: true,
            onClick: () => { this.cpntSelectNovoOptFechar(false) }
          },
          salvar: {
            status: '',
            texto: 'Salvar',
            class: [ 'btn', 'btn-primary' ],
            mostrar: true,
            onClick: () => { this.cpntSelectNovoOptFechar(true) }
          }
        }
      }
    },
    mounted: function () {
      this.cpntSelectIniciar()
    },
    beforeDestroy: function () {
      this.select.select2('close')
    },
    methods: {
      cpntSelectFechar: function () {
        this.select.select2('close')
      },
      cpntSelectTrigger: function () {
        this.select.val(this.value).trigger('change')
      },
      cpntSelectIniciar: function () {
        // SETA O CAMPO QUE TERÁ O SELECT2
        this.select = $(this.$refs.select)
        
        // SETA A CLASSE DO CAMPO
        this.config.containerCssClass += ' cpnt-select__' + this.cpntId
        this.config.dropdownCssClass += ' cpnt-select__' + this.cpntId

        // INICIA A VARIAVEL
        var parar = false

        // PEGA O CAMPO QUE ESTÁ SENDO CARREGADO
        var target = this.$refs.select
        
        // PROCURA O ELEMENTO PAI PRA SABER SE ESTÁ DENTRO DE UM SELECT2
        while (parar === false) {
          if (target.tagName === 'BODY' || target.className.indexOf('app-dialog') !== -1) {
            parar = true
          } else {
            target = target.parentElement
          }
        }

        // VERIFICA SE DEVE INCLUIR A CLASS PARA DIALOG
        if (target.className.indexOf('app-dialog') !== -1) {
          this.config.containerCssClass += ' cpnt-select-drop-in-dialog '
          this.config.dropdownCssClass  += ' cpnt-select-drop-in-dialog '
        }
        
        // CRIA O SELECT2
        this.select.select2(this.config)

        // PEGA O EVENTO DE ABERTURA DO SELECT
        this.select.on('select2-open', this.cpntSelectEventOpen)
        this.select.on('select2-close', () => { $('#select2-drop-mask').removeClass(this.config.containerCssClass) })
        this.select.on('change', this.cpntSelectEventChange)

        // VERIFICA SE TEM A FUNÇÃO ENTER
        if (this.cpntSelectOnKeyPressEnter !== null && typeof this.cpntSelectOnKeyPressEnter === 'function') {
          // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
          const CRIAR_OBSERVADOR_ENTER_SELECT2 = require('@/assets/js/Funcoes-Gerais.js').CRIAR_OBSERVADOR_ENTER_SELECT2

          // CARREGA O OBSERVADOR DO CAMPO
          CRIAR_OBSERVADOR_ENTER_SELECT2(this.cpntId, this.cpntSelectOnKeyUp)
        }

        // MONTA OS OPTIONS DO SELETOR
        this.cpntSelectAtualizar()
      },
      cpntSelectOnKeyUp: function (event) {
        // PEGA O CAMPO DO SELETOR INFORMADO
        var input = this.select[0].parentElement.querySelector('input')

        // VERIFICA SE EXISTE O INPUT SOLICITADO
        if ([ '', null, undefined ].indexOf(input) === -1 && input.className.indexOf('select2') !== -1) {
          if (event.which === 13) {
            this.cpntSelectOnKeyPressEnter(event)
          }
        }
      },
      cpntSelectOnKeyPressEnter: function (event) {
        if (this.cpntOnKeyPressEnter !== null) {
          // MANDA PARAR O EVENTO 
          event.preventDefault()
          
          // CHAMA A FUNÇÃO DO ENTER
          this.cpntOnKeyPressEnter(this.cpntId, event)
        }
      },
      cpntSelectAtualizar: function () {
        // LIMPA A BUSCA DE OPTIONS
        this.buscarOption = true

        // MONTA OS OPTIONS DO SELETOR
        this.cpntSelectMontarOptions()

        // MONTA OS OPTIONS DO SELETOR
        this.cpntSelectMontarValor()

        // SELECIONA O VALOR DO CAMPO
        setTimeout(() => { this.cpntSelectTrigger() }, 0)
      },
      cpntSelectMontarOptions: function () {
        // INICIA A VARIAVEL DE OPTIONS
        var options = {}
        var optionsV = []

        // INICIA A VARIVEL QUE VAI RECEBER O VALOR
        var item = ''

        // VERIFICA SE TERÁ A OPÇÃO SELECIONE
        if ([ '', null, undefined ].indexOf(this.option) === -1 && this.option._id === '__NOVO_OPTION__') {
          // MONTA O OPTION PARA O SELETOR
          item = this.cpntSelectMontarOption(JSON.parse(JSON.stringify(this.option)))

          // ADICIONA O OPTION AO VETOR
          options[item._id.toString()] = item

          // ADICIONA O ITEM AOS OPTIONS
          optionsV.push(item)
        }

        // VERIFICA SE TERÁ A OPÇÃO SELECIONE
        if ([ '', null, undefined ].indexOf(this.cpntOptionInicialNome) === -1) {
          // INICIA O OPTION SELECIONE
          item = { _id: this.cpntOptionInicialValue, _text: this.cpntOptionInicialNome }

          // INICIA O VALOR DA OPÇÃO SELECIONE
          if ([ null, undefined ].indexOf(item[this.cpntKeyValue]) !== -1) {
            item[this.cpntKeyValue] = this.cpntOptionInicialValue
          }
          
          // ADICIONA O OPTION AO VETOR
          options[item._id.toString()] = item

          // ADICIONA O ITEM AOS OPTIONS
          optionsV.push(item)
        }

        // VERIFICA SE TEM OPTION INICIAL
        if ([ '', null, undefined ].indexOf(this.cpntValue) === -1 && typeof this.cpntValue === 'object' && this.cpntOptions.length === 0) {
          // MONTA O OPTION PARA O SELETOR
          item = this.cpntSelectMontarOption(this.cpntValue)

          // ADICIONA O OPTION AO VETOR
          options[item._id.toString()] = item

          // ADICIONA O ITEM AOS OPTIONS
          optionsV.push(item)
        }

        // RODA O VETOR MONTANDO OS OPTIONS
        for (var indexO in this.cpntOptions) {
          if (this.cpntOptions[indexO].optgroup !== undefined && this.cpntOptions[indexO].options !== undefined) {
            // INICIA O GRUPO DE VALORES
            var optgroup = { optgroup: this.cpntOptions[indexO].optgroup, options: [] }

            // RODA O VETOR MONTANDO OS VALORES
            for (var indexV in this.cpntOptions[indexO].options) {
              // MONTA O OPTION PARA O SELETOR
              item = this.cpntSelectMontarOption(this.cpntOptions[indexO].options[indexV])

              // ADICIONA O OPTION AO VETOR
              options[item._id.toString()] = item

              // ADICIONA O ITEM AOS OPTIONS
              optgroup.options.push(item)
            }

            // ADICIONA O ITEM AOS OPTIONS
            optionsV.push(optgroup)
          } else {
            // MONTA O OPTION PARA O SELETOR
            item = this.cpntSelectMontarOption(this.cpntOptions[indexO])

            // ADICIONA O OPTION AO VETOR
            options[item._id.toString()] = item

            // ADICIONA O ITEM AOS OPTIONS
            optionsV.push(item)
          }
        }

        // SETA OS OPTIONS DO SELETOR
        this.options = JSON.parse(JSON.stringify(options))

        // SETA OS OPTIONS DO SELETOR
        this.optionsV = JSON.parse(JSON.stringify(optionsV))
      },
      cpntSelectMontarOption: function (vetor) {
        // MONTA A VARIAVEL OPTION
        var option = Object.assign({ _id: '', _text: '' }, vetor)

        // SETA O VALOR RECEBIDO
        if (vetor._id !== undefined && vetor._text !== undefined) {
          option = vetor
        } else {
          // MONTA O LABEL DO OPTION
          for (var indexV in this.cpntKeyMostra) {
            // PEGA O NOME DA CHAVE
            var chave = this.cpntKeyMostra[indexV]

            // VERIFICA SE A CHAVE EXISTE E SE TEM VALOR A SER MONTADO
            option._text += (vetor[chave] !== undefined ? vetor[chave] : chave)
          }

          // SETA O VALOR DO OPTION
          option._id = vetor[this.cpntKeyValue]
        }

        // CONVERTE OS VALORES PARA STRING
        option._id = option._id.toString()
        option._text = option._text.toString()

        // RETORNA O VALOR MONTADO
        return option
      },
      cpntSelectMontarValor: function () {
        // INCIA A VARIAVEL VALOR
        var value = ''

        // PEGA O OPTION SELECIONADO
        var option = { _id: '', _text: '' }

        // VERIFICA SE É O VALOR O OPTION DO CAMPO
        if ([ '', null, undefined ].indexOf(this.cpntValue) === -1) {
          switch (typeof this.cpntValue) {
            case 'object':
              // PEGA O OPTION SELECIONADO
              option = this.cpntSelectMontarOption(this.cpntValue)

              // SETA O VALUE DO CAMPO
              value = option._id
              break

            default:
              // SETA O VALUE DO CAMPO
              value = this.cpntValue

              // PEGA O VALOR SELECIONADO
              if ([ '', null, undefined ].indexOf(option) !== -1) {
                // PROCURA O OPTION INFORMADO
                option = this.optionsV.filter(item => item._text === this.cpntValue)

                // PEGA O VALOR SELECIONADO
                option = option.length >= 1 ? option[0] : this.cpntValue
              }

              // SETA COMO UM NOVO OPTION SELECIONADO
              if (option._id !== value && option._id === '__NOVO_OPTION__') {
                value = option._id
              }
              break
          }
        }

        // SETA O VALOR SELECIONADO
        this.value = value

        // SETA O OPTION SELECIONADO
        this.option = option
      },
      cpntSelectEventOpen: function (event) {
        // REMOVE O FOCUS DOS OUTROS CAMPOS
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // REMOVE A CLASS DO CAMPO
        if (this.config.containerCssClass !== '') {
          $('#select2-drop-mask').addClass(this.config.containerCssClass)
        }

        // VERIFICA SE ESTÁ ABRINDO O SELECT2
        if (this.buscarOption === true && this.cpntOptions.length === 0 && this.cpntOnBuscarOptions !== null) {
          // PARA O PROCESSO DE ABERTURA
          event.preventDefault()

          // TRAVA A BUSCA DE OPTIONS
          this.buscarOption = false

          // ATIVA O CARREGAMENTO DO CAMPO
          this.loading = true

          // FECHA O SELECT PARA BUSCAR OPTIONS
          this.select.select2('close')

          // FAZ A BUSCA DOS OPTIONS
          this.cpntOnBuscarOptions(() => {
            setTimeout(() => {
              // RETIRA O CARREGAMENTO DO CAMPO
              this.loading = false

              // ABRE O SELECT APÓS RECEBER OS OPTIONS
              this.select.select2('open')
            }, 100)
          }, this.cpntId)
        }
        
        // VERIFICA O CAMPO QUE DEVE DEIXAR NEGRITO
        if (this.cpntOptionBold !== null) {
          setTimeout(() => {
            // PEGA O NUMERO DA LINHA QUE DEVE TRABALHAR
            var index = this.optionsV.findIndex(item => item[this.cpntKeyValue].toString() === this.cpntOptionBold.toString())

            // VERIFICA SE ACHOU O OPTION SOLICITADO
            if (index !== -1) {
              // PEGA OS OPTIONS NA TELA
              var options = $('#select2-drop.cpnt-select__' + this.cpntId)[0].querySelectorAll(".select2-results > li")

              // SETA O NEGRITO NA LINHA DESEJADA
              options[index].style = 'font-weight: bold;'
            }
          }, 50)
        }
      },
      cpntSelectEventChange: function () {
        // SETA O VALUE DO CAMPO
        var value = this.select.val()

        // VERIFICA SE É PARA ADICIONAR NOVO OPTION
        if (value === '__ADD__NOVO_OPTION__') {
          if ([ '', null, undefined ].indexOf(this.cpntNewOption) === -1 && typeof this.cpntNewOption === 'function') {
            // ABRE O SELECT APÓS RECEBER OS OPTIONS
            this.select.select2('open')

            // FECHA O SELECT PARA BUSCAR OPTIONS
            setTimeout(() => { this.select.select2('close') }, 100)

            // EXECUTA A FUNÇÃO RECEBIDA
            setTimeout(() => { this.cpntNewOption() }, 200)
          } else {
            // MANDA ADICIONAR NOVO OPTION
            this.novoOpt = true

            // LIMPA O VALOR DO CAMPO
            this.campos.nome.value = ''

            // REALIZA O FOCUS NO CAMPO
            this.cpntSelectFocusCampo('nome')
          }
        } else {
          // INICIA A VARIAVEL
          var option = null

          // PEGA O VALOR SELECIONADO
          if (value !== null) {
            option = this.options[value]
          }
  
          // INICIA A VARIAVEL
          var item = { _id: '__', _text: 'INICIO' }
          
          // VERIFICA SE É O VALOR O OPTION DO CAMPO
          if ([ null, undefined ].indexOf(this.cpntValue) === -1) {
            switch (typeof this.cpntValue) {
              case 'object':
                item = this.cpntSelectMontarOption(this.cpntValue)
                break
            }
          }

          // REMOVE O CAMPO DO VALOR SELECIONADO
          if (option === null && option === value) {
            if (this.$refs.cpnt_select !== undefined) {
              // PEGA O CAMPO QUE SERÁ REMOVIDO
              var campo = this.$refs.cpnt_select.querySelector('.cpnt-select2-value-selected')
              
              // VERIFICA SE FOI ENCONTRADO O CAMPO QUE DEVE REMOVER
              if ([ '', null, undefined ].indexOf(campo) === -1) {
                campo.remove()
              }
            }
          }
  
          // VERIFICA SE TEM VALOR PARA ATUALIZAR
          if ([ '', null, undefined ].indexOf(item) === -1 && [ '', null, undefined ].indexOf(option) === -1 && item._id !== option._id) {
            this.cpntOnChange(option, this.cpntId)
          }
        }
      },
      cpntSelectOnChangeCampo: function (value) {
        // LIMPA O VALOR DO CAMPO
        this.campos.nome.value = value

        // LIMPA O CAMPO MENSAGEM
        this.campos.nome.mensagem = ''
      },
      cpntSelectNovoOptFechar: function (atualizar) {
        // VERIFICA SE DEVE CRIAR UMA NOVA OPÇÃO NO SELETOR
        if (atualizar === true && this.campos.nome.value.length < 3) {
          this.$store.state.msgWarn('WEB [400]: O nome da nova opção deve conter mais de 2 caracteres.', 'warning')
        } else {
          // REMOVE O FOCUS DE QUALQUER CAMPO
          if (document.activeElement !== document.body) {
            document.activeElement.blur()
          }

          // MANDA ADICIONAR NOVO OPTION
          this.novoOpt = false

          // VERIFICA SE DEVE FECHAR OU NÃO A TELA
          if (atualizar === true) {
            // INICIA A VARIAVEL
            var item = { _id: '__NOVO_OPTION__', _text: this.campos.nome.value }

            // SETA O VALOR DO NOVO CAMPO
            item[this.cpntKeyValue] = item._id

            // ADICIONA O OPTION AO VETOR
            this.options[item._id.toString()] = item

            // ADICIONA O ITEM AOS OPTIONS
            this.optionsV.unshift(item)

            // SETA O VALOR SELECIONADO
            this.value = item._id

            // SETA O OPTION SELECIONADO
            this.option = item

            // REALIZA O TRIGGER PARA ATUALIZAR O SELETOR
            setTimeout(() => { this.cpntSelectTrigger() }, 0)
          } else {
            // MONTA O VALOR SELECIONADO NO OPTION
            this.cpntSelectMontarValor()

            // REALIZA O TRIGGER PARA ATUALIZAR O SELETOR
            setTimeout(() => { this.cpntSelectTrigger() }, 0)
          }
        }
      },
      cpntSelectFocusCampo: function (campo, tentativa = 0) {
        if (tentativa <= 10) {
          // SETA A FUNÇÃO DE REINICIAR
          var reiniciar = () => { setTimeout(() => { this.cpntSelectFocusCampo(campo, (tentativa + 1)) }, 100) }

          // VERIFICA SE O CAMPO EXISTE
          if (tentativa >= 2 && [ '', null, undefined ].indexOf(this.$refs[campo]) === -1) {
            // PEGA O ELEMENTO QUE DEVE DAR FOCUS
            var elemento = Array.isArray(this.$refs[campo]) === true ? this.$refs[campo][0] : this.$refs[campo]

            // VERIFICA SE O ELEMENTO EXISTE
            if ([ '', null, undefined ].indexOf(elemento) === -1 && [ '', null, undefined ].indexOf(elemento.cpntRealizarFocus) === -1 && typeof elemento.cpntRealizarFocus === 'function') {
              elemento.cpntRealizarFocus()
            } else {
              reiniciar()
            }
          } else {
            reiniciar()
          }
        }
      },
      cpntSelectTratarOptionSelecionado: function (event, selecionado = false) {
        // INICIA A VARIAVEL
        var optgroup = '<div class="cpnt-select2-value-selected"><font class="cpnt-select2-value-selected">' + event.text + '</font></div>'

        // PEGA O ELEMENTO OPTION
        var element = (Array.isArray(event.element) === true && event.element.length >= 1 ? event.element[0] : event.element)

        // VERIFICA SE TEM O OPTION GROUP
        if (event.id === '__ADD__NOVO_OPTION__') {
          optgroup = '<img class="cpnt-select-img-option cpnt-select-img-new-option" src="/img/icones/mais.png" onerror="this.src=\'/img/banco/em_branco.png\'"/><i>' + event.text + '</i>'
        } else if (selecionado === true && [ '', null, undefined ].indexOf(element.parentElement) === -1 && element.parentElement.tagName === 'OPTGROUP') {
          if ([ '', null, undefined ].indexOf(element.parentElement.label) === -1) {
            optgroup = '<div <div class="cpnt-select2-optgroup">'
              optgroup += '<div class="cpnt-select2-optgroup-title cpnt-select2-value-selected">'
                optgroup += '<font size="-2">' + element.parentElement.label + '</font>'
              optgroup += '</div>'
              optgroup += '<div class="cpnt-select2-optgroup-text cpnt-select2-value-selected">'
                optgroup += '<font size="-1">' + event.text + '</font>'
              optgroup += '</div>'
            optgroup += '</div>'
          }
        } else if ([ '', null, undefined ].indexOf(this.options[event.id]) === -1 && [ '', null, undefined ].indexOf(this.options[event.id]._formatar) === -1) {
          // PEGA OS OPTION
          var option = JSON.parse(JSON.stringify(this.options[event.id]))

          // INICIA A CHAVE QUE SERÁ MOSTRADO NO LABEL
          option._label = ''

          // MONTA O VALOR DO OPTION
          for (var indexV in option._formatar) {
            // PEGA O NOME DA CHAVE
            var chave = option._formatar[indexV]

            // VERIFICA SE A CHAVE EXISTE E SE TEM VALOR A SER MONTADO
            option._label += (option[chave] !== undefined ? option[chave] : chave)
          }

          // SETA O VALOR SELECIONADO
          optgroup = option._label
        }

        // VERIFICA SE TEM IMAGEM A SER COLOCADA NO VALOR
        if ([ '', null, undefined ].indexOf(this.options[event.id]) === -1 && [ '', null, undefined ].indexOf(this.options[event.id]._img) === -1) {
          optgroup = '<img class="cpnt-select-img-option cpnt-select-img-new-option" src="' + this.options[event.id]._img + '"/></img>' + optgroup
        }

        // RETORNA O VALOR MONTADO
        return optgroup
      },
      cpntRealizarFocus: function (open = true, travaOpt = false, tentativa = 0) {
        if (tentativa <= 10) {
          if ([ '', null, undefined ].indexOf(this.select) !== -1 || [ '', null, undefined ].indexOf(this.select.select2) !== -1 || this.cpntDisabled !== false) {
            setTimeout(() => { this.cpntRealizarFocus(open, travaOpt, (tentativa + 1)) }, 200)
          } else {
            // MANDA ABRIR O SELECT2
            this.select.select2('open')

            // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
            const FUN_POSICIONAR_SCROLL_FOCUS_CAMPO = require('@/assets/js/Funcoes-Gerais.js').FUN_POSICIONAR_SCROLL_FOCUS_CAMPO

            // EXECUTA A FUNÇÃO IMPORTADA
            FUN_POSICIONAR_SCROLL_FOCUS_CAMPO(this.$refs.cpnt_select)
    
            // FECHA O SELECT SE É APENAS PARA DAR FOCUS NO CAMPO
            if (open !== true) {
              setTimeout(() => { this.select.select2('close') }, 100)
            }
          }
        }
      }
    },
    watch: {
      cpntOptions: function () {
        this.cpntSelectAtualizar()
      },
      cpntValue: function () {
        this.cpntSelectAtualizar()
      },
      cpntOptionInicialValue: function () {
        this.cpntSelectAtualizar()
      },
      cpntOptionInicialNome: function () {
        this.cpntSelectAtualizar()
      }
    },
    computed: {
      cpntSelectMontarClass: function () {
        // INICIA O VALOR QUE SERÁ RETORNADO
        var valor = []

        // VERIFICA SE TEM ALGUMA MENSAGEM DE VALIDAÇÃO
        if ([ '', null, undefined ].indexOf(this.cpntMensagem) === -1) {
          valor.push('cpnt-app-campo-has-error')
        }

        // VERIFICA SE É FILTRO ESTE CAMPO
        if (this.cpntFiltro === true) {
          valor.push('cpnt-filtros')
        }

        // VERIFICA SE TEM ALERTA PARA O CAMPO
        if ([ '', null, undefined ].indexOf(this.cpntAlerta) === -1) {
          valor.push('cpnt-app-campo-alerta')
        }
        
        // RETORNA O VALOR MONTADO
        return valor
      }
    }
  }
</script>
